import {Page} from 'Core/models/Page';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {get} from 'Shared/utilities/fetchHelpers';
import {CustomerSupportFilter} from 'Users/ducks/CustomerSupport';
import {UserModel} from 'Users/models/UserModel';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {CustomerSupportApi} from 'Users/api';

const customerSupportApi = new CustomerSupportApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export const customerSupportRootUri = '/users/customersupport';

export default {
  searchCustomerSupportUsers: (
    applicationids: number[],
    filter?: CustomerSupportFilter,
    encryptedIdentifier?: string,
    recruiterCodes?: string
  ) =>
    get<Page<UserModel>>(
      `${customerSupportRootUri}${addFilterParameters({
        encryptedIdentifier,
        applicationids,
        ...filter,
        recruiterCodes,
      })}`
    ),
};
